import React from 'react';
import { OuterContainer, GlyphContainer } from './ProductHighlights.style';
import { Glyph, GlyphType } from 'components/global/Glyphs';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

export type ProductHighlightsProps = {
  glyphs: GlyphType[];
  device?: 'Desktop Only' | 'Mobile Only' | 'All Devices' | 'None';
  backgroundColor?: string;
};

const moduleName = 'productHighlights';

export const ProductHighlights = ({
  glyphs,
  device,
  backgroundColor,
}: ProductHighlightsProps) => (
  <OuterContainer
    data-module={moduleName}
    backgroundColor={backgroundColor}
    css={
      device === 'Desktop Only'
        ? desktopOnly()
        : device === 'Mobile Only'
        ? mobileOnly()
        : {}
    }
    displayContent={device !== 'None'}
  >
    <GlyphContainer>
      {glyphs.map((glyph, index) => (
        <Glyph key={index} content={glyph} />
      ))}
    </GlyphContainer>
  </OuterContainer>
);
